import React, { Component, Suspense } from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import SuspenseIconLoader from './SuspenseIconLoader';

// DummyIcon component to show when no matching icon is found
const DummyIcon = () => <></>;

class WindowIcons extends Component {
    render() {
        const { windowIcon, ...props } = this.props;

        // Function to dynamically import the correct icon
        let LazyWindowIcon;
        try {
            LazyWindowIcon = React.lazy(() => 
                import(`./WindowIconList`).then(module => {
                    // Check if the windowIcon exists in the module
                    if (module[windowIcon]) {
                        return { default: module[windowIcon] };
                    }
                    // If the icon doesn't exist, return the DummyIcon
                    return { default: DummyIcon };
                })
            );
        } catch (error) {
            // Fallback to DummyIcon if there is an error in dynamic import
            LazyWindowIcon = DummyIcon;
        }

        return (
            <Wrp>
                <Suspense fallback={<SuspenseIconLoader />}>
                    <LazyWindowIcon {...props} />
                </Suspense>
            </Wrp>
        );
    }
}

export default WindowIcons;

// import React,{Component} from 'react';
// import Wrp from '../../hoc/Wrp/Wrp';
// import {WindowIcon1,WindowIcon2,WindowIcon3,WindowIcon4,WindowIcon5,WindowIcon6,WindowIcon7,WindowIcon8,WindowIcon9,WindowIcon10,WindowIcon11,WindowIcon12,WindowIcon13,WindowIcon14
// ,WindowIcon15,WindowIcon16,WindowIcon17,WindowIcon18,WindowIcon19,WindowIcon20,WindowIcon21,WindowIcon22,WindowIcon23,WindowIcon24,WindowIcon25,WindowIcon26,WindowIcon27,WindowIcon28} from './WindowIconList' ;

// class WindowIcons extends Component {
//     render() {
//         // console.log('WindowIcon',this.props);
//         let WindowIcon = null;
//         switch(this.props.windowIcon){
//             case 'WindowIcon1':
//                 WindowIcon = <WindowIcon1 {...this.props}/>
//                 break;
//             case 'WindowIcon2':
//                 WindowIcon = <WindowIcon2 {...this.props}/>
//                 break;
//             case 'WindowIcon3':
//                 WindowIcon = <WindowIcon3 {...this.props}/>
//                 break;
//             case 'WindowIcon4':
//                 WindowIcon = <WindowIcon4 {...this.props}/>
//                 break;
//             case 'WindowIcon5':
//                 WindowIcon = <WindowIcon5 {...this.props}/>
//                 break;
//             case 'WindowIcon6':
//                 WindowIcon = <WindowIcon6 {...this.props}/>
//                 break;
//             case 'WindowIcon7':
//                 WindowIcon = <WindowIcon7 {...this.props}/>
//                 break;
//             case 'WindowIcon8':
//                 WindowIcon = <WindowIcon8 {...this.props}/>
//                 break;
//             case 'WindowIcon9':
//                 WindowIcon = <WindowIcon9 {...this.props}/>
//                 break;
//             case 'WindowIcon10':
//                 WindowIcon = <WindowIcon10 {...this.props}/>
//                 break;
//             case 'WindowIcon11':
//                 WindowIcon = <WindowIcon11 {...this.props}/>
//                 break;
//             case 'WindowIcon12':
//                 WindowIcon = <WindowIcon12 {...this.props}/>
//                 break;
//             case 'WindowIcon13':
//                 WindowIcon = <WindowIcon13 {...this.props}/>
//                 break;
//             case 'WindowIcon14':
//                 WindowIcon = <WindowIcon14 {...this.props}/>
//                 break;
//             case 'WindowIcon15':
//                 WindowIcon = <WindowIcon15 {...this.props}/>
//                 break;
//                 case 'WindowIcon16':
//                     WindowIcon = <WindowIcon16 {...this.props}/>
//                     break;
//                 case 'WindowIcon17':
//                     WindowIcon = <WindowIcon17 {...this.props}/>
//                     break;
//                 case 'WindowIcon18':
//                     WindowIcon = <WindowIcon18 {...this.props}/>
//                     break;
//                 case 'WindowIcon19':
//                     WindowIcon = <WindowIcon19 {...this.props}/>
//                     break;
//                 case 'WindowIcon20':
//                     WindowIcon = <WindowIcon20 {...this.props}/>
//                     break;
//                 case 'WindowIcon21':
//                     WindowIcon = <WindowIcon21 {...this.props}/>
//                     break;
//                 case 'WindowIcon22':
//                     WindowIcon = <WindowIcon22 {...this.props}/>
//                     break;
//                 case 'WindowIcon23':
//                     WindowIcon = <WindowIcon23 {...this.props}/>
//                     break;
//                 case 'WindowIcon24':
//                     WindowIcon = <WindowIcon24 {...this.props}/>
//                     break;
//                 case 'WindowIcon25':
//                     WindowIcon = <WindowIcon25 {...this.props}/>
//                     break;
//                 case 'WindowIcon26':
//                     WindowIcon = <WindowIcon26 {...this.props}/>
//                     break;
//                 case 'WindowIcon27':
//                     WindowIcon = <WindowIcon27 {...this.props}/>
//                     break;
//                 case 'WindowIcon28':
//                     WindowIcon = <WindowIcon28 {...this.props}/>
//                     break;
//                 default :
//                 WindowIcon  =<></>;  
//         }
//         // console.log('WindowIconLoader',WindowIcon);
//         return(
//             <Wrp>
//                 {WindowIcon}
//             </Wrp>
//         );
//     }

// }
// export default WindowIcons;